<mat-toolbar class="mat-elevation-z8">
  {{orderShuttleVM?.shuttleTypeName}} {{getShuttleDateType()}}<div class="spacer"></div>
</mat-toolbar>

@if (isLoading) {
<div class="spinner">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
}

<mat-dialog-content class="mt-3">

  <form [formGroup]="editShuttleForm">

    <table>

      <tr>
        <td colspan="2">
          <mat-form-field appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status">
              @for (option of statusOptions; track option) {
              <mat-option [value]="option.value">
                {{option.name}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </tr>

      @if (getShuttleDateType() !== 'TIMETABLE') {
      <tr>
        <td colspan="2">
          <mat-radio-group [(ngModel)]="bookingType" [ngModelOptions]="{standalone: true}"
            class="radio-group radio-group--spaced" (ngModelChange)="onBookingTypeChange($event)">
            <mat-radio-button value="flight">Flight</mat-radio-button>
            <mat-radio-button value="hotel">Hotel</mat-radio-button>
          </mat-radio-group>
        </td>
      </tr>
      }

      @if (getShuttleDateType() === 'FLIGHT') {
      <tr>
        <td colspan="2">
          <mat-form-field appearance="outline" (click)="picker3.open()">
            <mat-label>Flygdatum</mat-label>
            <input matInput [min]="minDate" [matDatepicker]="picker3" formControlName="flightDate"
              (dateChange)="flightDateChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker touchUi #picker3></mat-datepicker>
            @if (!editShuttleForm.controls.flightDate.valid && editShuttleForm.controls.flightDate.touched) {
            <mat-error>
              Felaktigt datum
            </mat-error>
            }
          </mat-form-field>
          @if (orderShuttleVM?.productType === 'ShuttleArrival') {
          <mat-form-field appearance="outline">
            <mat-label>Avgående flight, tid och terminal</mat-label>
            <input type="text" matInput formControlName="flightArrivalTime" [matAutocomplete]="autoArrival">
            <mat-autocomplete #autoArrival="matAutocomplete" [displayWith]="displayAutocompleteFn">
              @for (arrival of filteredArrivals | async; track arrival) {
              <mat-option [value]="arrival">
                <div class="flex flex-row">
                  <span>
                    {{arrival.arrivalCode}} {{arrival.departureStation}} :
                    {{arrival.scheduledArrival | date: 'HH:mm'}}
                  </span>
                  <div class="spacer"></div>
                  <span> {{arrival.stationCode}} : {{arrival.terminalName}}</span>
                </div>
              </mat-option>
              }
            </mat-autocomplete>
            <mat-icon matSuffix>flight_land</mat-icon>
            @if (!editShuttleForm.controls.flightArrivalTime.valid &&
            editShuttleForm.controls.flightArrivalTime.touched) {
            <mat-error>
              Felaktig tid
            </mat-error>
            }
          </mat-form-field>
          }
          @if (orderShuttleVM?.productType === 'ShuttleDeparture') {
          <mat-form-field appearance="outline">
            <mat-label>Avgående flight, tid och terminal</mat-label>
            <input type="text" matInput formControlName="flightDepartureTime" [matAutocomplete]="autoDepartures">
            <mat-autocomplete #autoDepartures="matAutocomplete" [displayWith]="displayAutocompleteFn">
              @for (departure of filteredDepartures | async; track departure) {
              <mat-option [value]="departure">
                <div class="flex flex-row">
                  <span>
                    {{departure.departureCode}} {{departure.arrivalStation}} :
                    {{departure.scheduledDeparture | date: 'HH:mm'}}
                  </span>
                  <div class="spacer"></div>
                  <span> {{departure.stationCode}} : {{departure.terminalName}}</span>
                </div>
              </mat-option>
              }
            </mat-autocomplete>
            <mat-icon matSuffix>flight_takeoff</mat-icon>
            @if (!editShuttleForm.controls.flightDepartureTime.valid &&
            editShuttleForm.controls.flightDepartureTime.touched) {
            <mat-error>
              Felaktig tid
            </mat-error>
            }
          </mat-form-field>
          }
        </td>
      </tr>
      }

      @if (getShuttleDateType() === 'TIMETABLE') {
      <tr>
        <td>
          <mat-form-field appearance="outline" (click)="picker3.open()">
            <mat-label>Busstur datum</mat-label>
            <input matInput [min]="minDate" [matDatepicker]="picker3" formControlName="timeTableDate"
              (dateChange)="timeTableDateChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker touchUi #picker3></mat-datepicker>
            @if (!editShuttleForm.controls.timeTableDate.valid && editShuttleForm.controls.timeTableDate.touched) {
            <mat-error>
              Felaktigt datum
            </mat-error>
            }
          </mat-form-field>
        </td>
        <td>
          <mat-form-field appearance="outline">
            <mat-label>Busstur tid</mat-label>
            <mat-select formControlName="timeTableTime">
              @for (route of plannedShuttleBusses; track route) {
              <mat-option [value]="route">
                <div class="flex flex-row">
                  <span>
                    Kl: {{route.startDate | date: 'HH:mm'}}
                  </span>
                  <div class="spacer"></div>
                  @if (route.seats != null) {
                  <span>Lediga platser ({{(route.seats -
                    route.passengers)}})</span>
                  }
                </div>
              </mat-option>
              }
              @if (plannedShuttleBusses.length === 0) {
              <mat-option>Inga bussturer
                tillgängliga</mat-option>
              }
            </mat-select>
            <mat-icon matSuffix>schedule</mat-icon>
            @if (!editShuttleForm.controls.timeTableTime.valid && editShuttleForm.controls.timeTableTime.touched) {
            <mat-error>
              Felaktig tid
            </mat-error>
            }
          </mat-form-field>
        </td>
      </tr>
      }

      @if (getShuttleDateType() === 'DEFAULT' || getShuttleDateType() === 'FLIGHT') {
      <tr>
        <td>
          <mat-form-field appearance="outline">
            <mat-label>Shuttledatum</mat-label>
            <input matInput formControlName="shuttleDate" [matDatepicker]="shuttleDate">
            <mat-datepicker-toggle matSuffix [for]="shuttleDate"></mat-datepicker-toggle>
            <mat-datepicker #shuttleDate></mat-datepicker>
          </mat-form-field>
        </td>
        <td>
          <mat-form-field appearance="outline">
            <mat-label>Shuttletid</mat-label>
            <input matInput type="time" value="{{shuttleDateTime}}" formControlName="shuttleDateTime">
            <mat-icon matSuffix>schedule</mat-icon>
          </mat-form-field>
        </td>
      </tr>
      }

      <!-- <tr *ngIf="getShuttleDateType() === 'DEFAULT' || getShuttleDateType() === 'TIMETABLE'">
      <td colspan="2">
        <mat-form-field appearance="outline">
          <mat-label>Flightnummer</mat-label>
          <input matInput formControlName="flightNr" placeholder="Ange Flightnummer">
          <mat-icon matSuffix>flight</mat-icon>
        </mat-form-field>
      </td>
    </tr> -->

      @if (getShuttleDateType() === 'DEFAULT' || getShuttleDateType() === 'TIMETABLE') {
      <tr>
        <td colspan="2">
          <!-- <div *ngIf="orderShuttleVM.terminal !== null" style="margin-bottom: 20px;">
          <b>{{orderShuttleVM.terminal}}</b>
        </div> -->
          <mat-form-field appearance="outline">
            <mat-label>Terminal</mat-label>
            <mat-select formControlName="terminal">
              @for (option of terminalOptions; track option) {
              <mat-option [value]="option.value">
                {{option.name}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </tr>
      }

      @if (departureVM && getShuttleDateType() === 'FLIGHT') {
      <tr>
        <td colspan="2">
          <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>flight_takeoff</mat-icon>&nbsp;&nbsp;Departure information
              </mat-panel-title>
            </mat-expansion-panel-header>
            <table>
              <tr>
                <td class="info-label-cell">Avgår till:</td>
                <td>{{departureVM.arrivalStation }}</td>
                <td class="info-label-cell">Operator: </td>
                <td>{{departureVM.operator }}</td>
              </tr>
              <tr>
                <td class="info-label-cell">Scheduled departure:</td>
                <td>{{departureVM.scheduledDeparture | date:'yyyy-MM-dd HH:mm'}}</td>
                <td class="info-label-cell">Status: </td>
                <td>{{departureVM.status}}</td>
              </tr>
              <tr>
                <td class="info-label-cell">Estimated departure:</td>
                <td>{{departureVM.estimatedDeparture | date:'yyyy-MM-dd HH:mm'}}</td>
                <td class="info-label-cell">Gate: </td>
                <td>{{departureVM.gate}}</td>
              </tr>
              <tr>
                <td class="info-label-cell">Actual departure:</td>
                <td>{{departureVM.actualDeparture | date:'yyyy-MM-dd HH:mm'}}</td>
                <td class="info-label-cell">Desk: </td>
                <td>{{departureVM.checkInDeskFrom}} - {{departureVM.checkInDeskTo}}
                  {{departureVM.checkInStatus}}</td>
              </tr>
              <tr>
                <td class="info-label-cell">Remarks:</td>
                <td>{{departureVM.remarks }}</td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </mat-expansion-panel>
        </td>
      </tr>
      }

      @if (arrivalVM && getShuttleDateType() === 'FLIGHT') {
      <tr>
        <td colspan="2">
          <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>flight_land</mat-icon>&nbsp;&nbsp;Arrival information
              </mat-panel-title>
            </mat-expansion-panel-header>
            <table>
              <tr>
                <td class="info-label-cell">Ankommer från:</td>
                <td>{{arrivalVM.departureStation }}</td>
                <td class="info-label-cell">Operator: </td>
                <td>{{arrivalVM.operator }}</td>
              </tr>
              <tr>
                <td class="info-label-cell">Scheduled arrival:</td>
                <td>{{arrivalVM.scheduledArrival | date:'yyyy-MM-dd HH:mm'}}</td>
                <td class="info-label-cell">Status: </td>
                <td>{{arrivalVM.status}}</td>
              </tr>
              <tr>
                <td class="info-label-cell">Estimated arrival:</td>
                <td>{{arrivalVM.estimatedArrival | date:'yyyy-MM-dd HH:mm'}}</td>
                <td class="info-label-cell">Gate: </td>
                <td>{{arrivalVM.gate}}</td>
              </tr>
              <tr>
                <td class="info-label-cell">Actual arrival:</td>
                <td>{{arrivalVM.actualArrival | date:'yyyy-MM-dd HH:mm'}}</td>
                <td class="info-label-cell">Baggageclaim: </td>
                <td>{{arrivalVM.baggageClaimUnit}}</td>
              </tr>
              <tr>
                <td class="info-label-cell">Remarks:</td>
                <td>{{arrivalVM.remarks}}</td>
                <td class="info-label-cell">Firstbag estimated</td>
                <td>{{arrivalVM.firstBagEstimated | date:'yyyy-MM-dd HH:mm'}}</td>
              </tr>
              <tr>
                <td class="info-label-cell"></td>
                <td></td>
                <td class="info-label-cell">Firstbag </td>
                <td>{{arrivalVM.firstBag | date:'yyyy-MM-dd HH:mm'}}</td>
              </tr>
              <tr>
                <td class="info-label-cell"></td>
                <td></td>
                <td class="info-label-cell">Lastbag </td>
                <td>{{arrivalVM.lastBag | date:'yyyy-MM-dd HH:mm'}}</td>
              </tr>
            </table>
          </mat-expansion-panel>
        </td>
      </tr>
      }
      @if (arrivalVM || departureVM) {
      <tr>
        <td colspan="2">&nbsp;</td>
      </tr>
      }
      <tr>
        <td colspan="2">
          <div class="flex-row">
            <mat-form-field appearance="outline" class="input-narrow input-narrow--gap">
              <mat-label>Passagerare</mat-label>
              <input formControlName="passengers" type="number" matInput placeholder="Välj antal passagerare">
              <mat-icon matSuffix>supervisor_account</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-narrow input-narrow--gap">
              <mat-label>Barnsäten</mat-label>
              <input formControlName="childSeats" type="number" matInput placeholder="Välj antal barnsäten">
              <mat-icon matSuffix>child_care</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-narrow">
              <mat-label>Baggage</mat-label>
              <input formControlName="baggage" type="number" matInput placeholder="Välj antal baggage">
              <mat-icon matSuffix>card_travel</mat-icon>
            </mat-form-field>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <mat-form-field appearance="outline">
            <mat-label>Kommentar</mat-label>
            <textarea formControlName="comment" type="text" matInput placeholder="Lägg till kommentar"
              rows="4"></textarea>
          </mat-form-field>
        </td>
      </tr>
    </table>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="mt-2 mb-4 mx-3" align="end">
  <button mat-raised-button color="primary" [disabled]="(editShuttleForm.status === 'INVALID' || isDisabled)"
    (click)="saveChanges()">{{'spara' | uppercase}}</button>
  <button mat-button mat-dialog-close>Stäng</button>
</mat-dialog-actions>